export default __webpack_public_path__ + "static/media/new pricing.0651951b.csv";